import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import EvaluatorLeadReportSearchParams from './EvaluatorLeadReportSearchParams';
import EvaluatorLeadService from '../../../Services/EvaluatorLeadService';

export default class EvaluatorLeadReportWindowDescription {
  static titleForCreate = 'Lead/Registration Report';
  static titleForEdit = 'Lead/Registration Report';
  static itemType = EvaluatorLeadReportSearchParams;
  // No waitForServiceFunction: the response's eventResult list must be shown, so the
  // wizard waits for the call (like the old panel's waitForResponseOnSubmit = true).
  static serviceFunction = EvaluatorLeadService.RequestEvaluatorLeadReport;
  static finishButtonLabel = 'Run Report';
  static messageOnSuccess = 'The report has been generated.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'UploadNewLeadList',
          label: 'Upload a New Lead List',
          className: 'col-12',
          type: InputTypesEnum.EmptyYesNoSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'LeadListFile',
          label: 'Lead List File',
          className: 'col-12',
          type: InputTypesEnum.FileUploadField,
          acceptedTypes: '.xlsx, .csv',
          fileTemplateFunction: EvaluatorLeadService.GetUploadTemplate,
          hide: (item) => !item.UploadNewLeadList || item.UploadNewLeadList.toString() === 'false',
          validityChecker: ValidityHelper.forRequiredFileField,
        },
        {
          fieldName: 'RegistrationDateFrom',
          label: 'Registration Period Start',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          hide: (item) => !item.UploadNewLeadList || item.UploadNewLeadList.toString() === 'true',
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'RegistrationDateTo',
          label: 'Registration Period End',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          hide: (item) => !item.UploadNewLeadList || item.UploadNewLeadList.toString() === 'true',
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'LeadDateFrom',
          label: 'Lead Date Start',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          hide: (item) => !item.UploadNewLeadList || item.UploadNewLeadList.toString() === 'true',
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'LeadDateTo',
          label: 'Lead Date End',
          className: 'col-6',
          type: InputTypesEnum.DateWithIndefinite,
          hide: (item) => !item.UploadNewLeadList || item.UploadNewLeadList.toString() === 'true',
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Form',
          label: 'Form',
          className: 'col-12',
          type: InputTypesEnum.Text,
          hide: (item) => !item.UploadNewLeadList || item.UploadNewLeadList.toString() === 'true',
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'OfficeIds',
          label: 'FW Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeOrGroupMultiSelect,
          hide: (item) => !item.UploadNewLeadList || item.UploadNewLeadList.toString() === 'true',
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CountryCodes',
          label: 'Country',
          className: 'col-12',
          type: InputTypesEnum.CountryCodeMultiChoice,
          hide: (item) => !item.UploadNewLeadList || item.UploadNewLeadList.toString() === 'true',
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
